import React from "react";
import StatusChip from "./StatusChip";
import { AD_STATUS } from "../../utils/enums";
import moment from "../../utils/moment";

interface Props {
  status: string;
  biddingEnds?: string | Date | null;
}

const AdStatusChip: React.FC<Props> = ({ status, biddingEnds }) => {
  // An ON_SALE ad whose biddingEnds has passed is effectively closed —
  // the daily close-a-bid cron just hasn't flipped the DB row yet. Render
  // it as "Closed" so this chip agrees with the time-based view in
  // useAdUtils on the details page.
  const effectiveStatus =
    status === AD_STATUS.ON_SALE &&
    biddingEnds &&
    moment().isAfter(moment(biddingEnds))
      ? AD_STATUS.CLOSED
      : status;

  switch (effectiveStatus) {
    case AD_STATUS.ON_SALE:
      return (
        <StatusChip tone="primary" icon="bi-tag-fill" label="On Sale" />
      );
    case AD_STATUS.SOLD:
      return (
        <StatusChip tone="success" icon="bi-check-circle-fill" label="Sold" />
      );
    case AD_STATUS.UNDER_REVIEW:
      return (
        <StatusChip tone="danger" icon="bi-eye-fill" label="Under Review" />
      );
    case AD_STATUS.APPROVED:
      return (
        <StatusChip tone="info" icon="bi-check2-circle" label="Approved" />
      );
    case AD_STATUS.CLOSED:
      return (
        <StatusChip tone="secondary" icon="bi-lock-fill" label="Closed" />
      );
    default:
      return null;
  }
};

export default AdStatusChip;
